import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    { path: '', component: () => import(/* webpackChunkName: "paginaInicial" */'../views/paginaInicial/paginaInicial.vue') },
    { path: '/servicos', component: () => import(/* webpackChunkName: "servicos" */'../views/servicos/servicos.vue') },
    { path: '/sobreNos', component: () => import(/* webpackChunkName: "sobreNos" */'../views/sobreNos/sobreNos.vue') },
    { path: '/esocial', component: () => import(/* webpackChunkName: "esocial" */'../views/eSocial/esocial.vue') },
    { path: '/contato', component: () => import(/* webpackChunkName: "contato" */'../views/contato/contato.vue') },
    { path: '/treinamento', component: () => import(/* webpackChunkName: "treinamento" */'../views/treinamentos/treinamento.vue') },
    { path: '/treinamento/:id', component: () => import(/* webpackChunkName: "treinamento" */'../views/treinamentos/treinamentoDetalhado.vue'), props: true },
    // { path: '/orcamento', component: () => import(/* webpackChunkName: "orcamento" */'../views/orcamento/orcamento.vue') },
    { path: '/politicaPrivacidade', component: () => import(/* webpackChunkName: "politicaPrivacidade" */'../views/paginaInicial/politicaPrivacidade.vue') }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js